const debtReportId = {
	debt_report: {
		title: "Laporan Hutang Pelanggan",
		table: {
			title: "Data Laporan Hutang Pelanggan",
			columns: {
				cust_name: "Nama Pelanggan",
				id_card: "No Kartu",
				debt_value: "Jumlah Hutang",
				status: "Status",
			},
		},
		status: {
			paid: "Lunas",
			unpaid: "Belum Lunas",
		},
		empty_state: {
			title: "Belum ada data laporan hutang dari pelanggan",
			description: "Belum ada data laporan hutang dari pelanggan",
		},
	},
};

export default debtReportId;
